import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { ModalController, Platform } from '@ionic/angular';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-cash-reinvest-modal',
  templateUrl: './cash-reinvest-modal.page.html',
  styleUrls: ['./cash-reinvest-modal.page.scss'],
})
export class CashReInvestModalPage implements OnInit, OnDestroy {
  @Input() userCashExcess: number;
  backSubscription: Subscription;

  constructor (
    private modalController: ModalController,
    private platform: Platform,
  ) {
    this.backSubscription = new Subscription();
  }

  ngOnInit() {
    if (this.platform.is('android')) {
      this.backSubscription.add(
        this.platform.backButton.subscribeWithPriority(9999, () => {
          this.dismissModal();
        }),
      );
    }
  }

  ngOnDestroy() {
    this.backSubscription.unsubscribe();
  }

  dismissModal() {
    this.modalController.dismiss();
  }
}
